import { Button, type ButtonProps } from '@mui/material';
import type { ReactNode } from 'react';
import { neobetRaisedActionButtonStyles as styles } from '../../../../styles/components/neobetRaisedActionButton';
import { mergeSx } from '../../../../utils/styles';
import NeobetRaisedActionButtonLabel from './NeobetRaisedActionButtonLabel';

type NeobetRaisedActionButtonVisualVariant = keyof typeof styles.variants;

type NeobetRaisedActionButtonProps = {
  component?: ButtonProps['component'];
  label: ReactNode;
  visualVariant?: NeobetRaisedActionButtonVisualVariant;
  showBorder?: boolean;
} & Omit<React.ComponentProps<typeof Button>, 'children'>;

const NeobetRaisedActionButton = ({
  label,
  sx,
  visualVariant,
  showBorder = false,
  ...buttonProps
}: NeobetRaisedActionButtonProps) => (
  <Button
    variant='contained'
    color='primary'
    sx={mergeSx(styles.button, visualVariant && styles.variants[visualVariant], showBorder && styles.withBorder, sx)}
    {...buttonProps}
  >
    <NeobetRaisedActionButtonLabel>{label}</NeobetRaisedActionButtonLabel>
  </Button>
);

export default NeobetRaisedActionButton;
